import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import Submit from 'components/Submit';
import * as constants from 'constants/App';
import { defineMessages, FormattedMessage,injectIntl,RawIntlProvider } from 'react-intl';
import { Table } from 'react-bootstrap';
import { Popover, Overlay } from 'react-bootstrap';
import * as helperFunctions from 'utils/HelperFunctions';
import classnames from 'classnames';
import './AuthEmailNotification.css';

const AuthEmailNotificationAddEdit = (props) => {
    const [fieldsFocusedAfterValidation, setFieldsFocusedAfterValidation] = useState([]); //array of fields that have recieved focus event, 
    const refList = useRef([]);
    const isRegisteredRef = useRef();

    useEffect(() => {
        refList.current = refList.current.slice(0, props.authorizationEmailConfig.length)
    }, [props.authorizationEmailConfig]);

    const toggleNotificationEmails = (isSelected, event) => {
        onFieldFocus( 'isRegistered');
        event.target.src = isSelected ? "/assets/VMS_checked.png" : "/assets/VMS_unchecked.png";
        event.target.value = isSelected;
        props.updateEmailConfigRegistration(isSelected);
    }
    const onRemove = (index) => {
        props.removeContact(index);
    }
    //Adds the field to the list of focused fields
    const onFieldFocus = (fieldName) => {
        let updatedFocusFields = fieldsFocusedAfterValidation.concat(fieldName);
        setFieldsFocusedAfterValidation(updatedFocusFields);
        props.removeValidationErrForAuthEmailConfig(fieldName);
    }
    const onSubmit = () => {
        setFieldsFocusedAfterValidation([]);
        props.onSubmitStep(5);
    }
  
    const onChange = (inputName, index, event) => {
        props.updateContact(inputName, index, event);
    }


    const renderValidationOverlay = (fieldName, index, placement) => {      
        let message;
        let element;

        if(fieldName==='isRegistered'){
            message = props.authorizationEmailConfigValidationErrs?.get(fieldName);
            element = isRegisteredRef.current;
        }
        else{
            message = props.authorizationEmailConfigValidationErrs?.get(index);    
            element = refList.current[index];
        } 
            
        let showError = message != undefined && !fieldsFocusedAfterValidation.includes(fieldName);
        if (message != undefined)
            return <Overlay
                show={showError}
                target={element}
                placement={placement != undefined ? placement : "right"}>
                <Popover id={"popOver" + fieldName} className="enrollment-details__error_message step1__popover">
                    <RawIntlProvider value={props.intl}>
                    <FormattedMessage {...message} />
                    </RawIntlProvider>
                </Popover>
            </Overlay>
        else
            return false;
    }


        const messages = defineMessages({
            notification_email: {
                id: 'notification_email',
                description: 'Step 5 of 5: Authorization Email Configuration',
                defaultMessage: 'Step 5 of 5: Authorization Email Configuration'
            },
            submit: {
                id: 'submit',
                description: 'Submit',
                defaultMessage: 'Submit'
            },
            note: {
                id: 'note',
                description: 'Checking Register indicates your acceptance of the authorization program.<br/>' +
                'Notification Emails will be delivered to the below address provided.<br/>' +
                'Additionally, you will also immediately be advised of the notification when logged into this website.<br/>',
                defaultMessage: 'Checking Register indicates your acceptance of the authorization program.<br/>' +
                'Notification Emails will be delivered to the below address provided.<br/>' +
                'Additionally, you will also immediately be advised of the notification when logged into this website.<br/>',
            },
            register: {
                id: 'register',
                description: 'Register',
                defaultMessage: 'Register'
            },
            edit_configuration_caption: {
                id: 'edit_configuration_caption',
                description: 'Edit Configurations',
                defaultMessage: 'Edit Configurations'
            },
            cancel: {
                id: 'cancel',
                description: 'Cancel',
                defaultMessage: 'Cancel'
            },
            save_contacts: {
                id: 'save_contacts',
                description: 'Save changes to contact information settings',
                defaultMessage: 'Save changes to contact information settings'
            },
            name_auth_email: {
                id: 'name_auth_email',
                description: 'name_auth_email',
                defaultMessage: 'Name'
            },
            optOut: {
                id: 'optOut',
                description: 'Opt out',
                defaultMessage: 'Opt out'
            },
            email_auth: {
                id: 'email_auth',
                description: 'email_auth',
                defaultMessage: 'Email Address'
            },
            add_new_contact: {
                id: 'add_new_contact',
                description: 'add_new_contact',
                defaultMessage: 'Add new contact'
            },
        });

        const isRegistered = props.isRegistered != undefined ? props.isRegistered : false;
        const optOut = props.isRegistered == undefined ? false : !props.isRegistered;
        const tabIndexGroup = props.tabIndexStartFrom;
        let tabIndexGroupForDynamicContacts = tabIndexGroup + 10;
        return (
            <div className={classnames(props.formMode == constants.EDIT ? 'auth-email-notification__edit' : 'auth-email-notification__add')}>
                <div className={classnames(props.formMode == constants.ADD ? 'auth-email-notification__header_add' : 'auth-email-notification__header_view')}>
                    {
                        props.title == undefined ?
                            <FormattedMessage {...messages.notification_email } />
                            : props.title
                    }
                </div>
                <div className={classnames('auth-email-notification__notification-emails', props.formMode == constants.ADD ? 'auth-email-notification__container_add' : undefined)}>
                    <div className=''>
                        {props.error}
                    </div>
                    <div className=''>
                        <div>
                            <FormattedMessage {...messages.note }  values={{ br: data => <br/> , b: data => <b>{data}</b>, a: data => <a>{data}</a>}}/>
                        </div>
                        <div className='row auth-email-notification__notification-options'>
                            <div className='row' style={{marginLeft: "initial"}}>
                                <div className='col auth-email-notification__notification-register' style={{display: "inline-flex"}}>
                                    <img className='auth-email-notification__notification-register-button'
                                        src={isRegistered ? "/assets/VMS_checked.png" : "/assets/VMS_unchecked.png"}
                                        onClick={toggleNotificationEmails.bind(this, true)}
                                        tabIndex = {tabIndexGroup+1} 
                                        />
                                    <label style={{fontWeight: 700}}>{' '}<FormattedMessage {...messages.register } /></label>
                                </div>
                                <div className='col auth-email-notification__notification-opt-out' css={`flex-basis: content;`}>
                                    <img className='auth-email-notification__notification-opt-out-button'
                                        src={optOut ? "/assets/VMS_checked.png" : "/assets/VMS_unchecked.png"}
                                        onClick={toggleNotificationEmails.bind(this, false)} 
                                        tabIndex = {tabIndexGroup+2} 
                                        />
                                    <label ref={isRegisteredRef} style={{fontWeight: 700}}>{' '}   <FormattedMessage {...messages.optOut} /></label>
                                </div>
                                {renderValidationOverlay('isRegistered', -1, 'right')}
                            </div>
                        </div>
                        <div>
                            <div className='auth-email-notification__contacts'>
                                <div className='row'>
                                    <div className='col-md-1'></div>
                                    <div className={classnames('col-md-4', 'auth-email-notification__contact-name-header',
                                        props.formMode == constants.ADD ? 'auth-email-notification__contact-name-header_add' : undefined)} > <FormattedMessage {...messages.name_auth_email} /></div>
                                    <div className={classnames('col-md-5', 'auth-email-notification__contact-email-header',
                                        props.formMode == constants.ADD ? 'auth-email-notification__contact-email-header_add' : undefined)} ><FormattedMessage {...messages.email_auth} /></div>
                                </div>
                                <div>
                                    {
                                        
                                        props.authorizationEmailConfig.map((item, index) => {
                                            tabIndexGroupForDynamicContacts = tabIndexGroupForDynamicContacts + index + 4;
                                            return <div className={classnames('row', props.formMode == constants.EDIT ? 'auth-email-notification__contact-row_edit' : 'auth-email-notification__contact-row_add')}>

                                                <div className='col-md-1 auth-email-notification__notification-contact-delete' >
                                                    <img className='auth-email-notification__delete-name'
                                                        src={"/assets/VMS_33button_kill_clear.png"}
                                                        onClick={onRemove.bind(this, index)}
                                                        onFocus={onFieldFocus.bind(this, index)}
                                                        tabIndex = {tabIndexGroupForDynamicContacts+1} 
                                                    />
                                                </div>
                                                <div className={classnames('col-md-4', props.formMode == constants.ADD ? 'auth-email-notification__name_add' : undefined)} >
                                                    <input type='text'
                                                        className=' auth-email-notification__name-input'
                                                        key={'name' + index}
                                                        maxLength={'75'}
                                                        onChange={onChange.bind(this, 'name', index)}
                                                        onFocus={onFieldFocus.bind(this, index)}
                                                        value={item.name} 
                                                        tabIndex = {tabIndexGroupForDynamicContacts+2} />
                                                </div>
                                                <div className={classnames('col-md-5', props.formMode == constants.ADD ? 'auth-email-notification__email_add' : undefined)} >
                                                    <input type='text'
                                                        className=' auth-email-notification__email-input'
                                                        maxLength={'75'}
                                                        key={'email' + index}
                                                        ref={el => refList.current[index] = el}
                                                        onChange={onChange.bind(this, 'email', index)}
                                                        value={item.email}
                                                        onFocus={onFieldFocus.bind(this, index)} 
                                                        tabIndex = {tabIndexGroupForDynamicContacts+3} />
                                                    {renderValidationOverlay('email' + index + props.formMode, index, 'right')}
                                                </div>

                                            </div>
                                        })
                                    }
                                </div>
                            </div>
                            <div>
                                <div className='auth-email-notification__add-contact'>
                                    <Submit caption={<FormattedMessage {...messages.add_new_contact } />}
                                        imagePath="/assets/VMS_28button_add_clear.png"
                                        onClickHandler={props.addContactRow} 
                                        tabIndex={tabIndexGroupForDynamicContacts+40}/>
                                </div>
                            </div>

                        </div>
                    </div>
                    {
                        props.formMode == constants.EDIT ?
                            <div className='row auth-email-notification__footer-buttons'>
                                <div className="col-md-3 auth-email-notification__cancel">
                                    <a
                                        onClick={props.onCancel != undefined ? props.onCancel : () => { }}
                                        tabIndex={tabIndexGroupForDynamicContacts+42}>
                                        <FormattedMessage {...messages.cancel} />{' '}
                                        <img src="/assets/VMS_28button_delete_blue.png" />
                                    </a>
                                </div>
                                <div className='col-md-9 auth-email-notification__save'>
                                    <Submit caption={<FormattedMessage {...messages.save_contacts } />}
                                        imagePath="/assets/VMS_28button_edit_clear.png"
                                        onClickHandler={onSubmit.bind(this)}
                                        showSpinner={props.isSubmittingAuthEmailConfigInfo} 
                                        spinnerType ={'blue'}
                                        tabIndex={tabIndexGroupForDynamicContacts+41}/>
                                </div>

                            </div>
                            : undefined
                    }

                </div>
                {
                    props.formMode == constants.ADD ?
                        <div className='auth-email-notification__submit'>
                            <Submit caption={<FormattedMessage {...messages.submit } />}
                                imagePath="/assets/VMS_33button_go_bblue.png"
                                onClickHandler={onSubmit.bind(this)}
                                showSpinner={props.isSubmittingAuthEmailConfigInfo} 
                                tabIndex={tabIndexGroupForDynamicContacts+43}/>
                        </div>
                        : undefined
                }
            </div>
        );
};

export default injectIntl(AuthEmailNotificationAddEdit);

